import React from 'react'
import { LoadingWrapper } from '../style'
import loading from 'assets/svg/loading-icon.svg'

interface LoadingSimulacaoProps {
  mainText?: string
  secondaryText?: string
  loadingIcon?: React.ReactElement
  isLoading: boolean
  children?: React.ReactNode
}

const LoadingComponent = ({
  mainText,
  secondaryText,
  loadingIcon,
  isLoading,
  children
}: LoadingSimulacaoProps) => {
  return (
    <>
      {isLoading ? (
        <LoadingWrapper>
          <div>{mainText}</div>
          <div>{secondaryText}</div>
          {loadingIcon ? (
            loadingIcon
          ) : (
            <img
              className="my-4"
              src={loading}
              alt="Loading sistema"
              width="100"
            />
          )}
        </LoadingWrapper>
      ) : (
        children
      )}
    </>
  )
}

export default LoadingComponent
